
import "core-js/stable";
import "regenerator-runtime/runtime";
/**
 * @author Vincent
 * @date 2018-7-18
 * @desc cloud pmss front end code
 */

// 写部署路径
window.sessionStorage.setItem('_host', window.location.href)

window.location.href = 'main.html#/Index'

  